<template>
  <div class="logo p" v-if="site.logos">
    <template v-if="inview">
      <img
        v-for="(img, index) in site.logos"
        :key="index"
        :class="{ active: scrollIndex == index }"
        :src="img.url"
        alt=""
      />
    </template>
    <!-- <img v-else class="defaultImg" src="../assets/00_Fragezeichen.svg" alt="" /> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      scrollIndex: 0,
      increment: 250
    };
  },
  mounted() {
    this.$root.$on("turnoff", this.turnOff);
    this.$root.$on("turnon", this.turnOn);
    if(window.innerWidth < 768) {
        setInterval(() => {
            if(this.scrollIndex == this.site.logos.length - 1) {
                this.scrollIndex = 0;
            } else {
                this.scrollIndex++;
            }
        }, 300);
    }
  },
  created() {
    window.addEventListener("scroll", this.changeQuestion);
  },
  destroyed() {
    window.removeEventListener("scroll", this.changeQuestion);
  },
  computed: {
    ...mapState(["site"]),
    inview() {
      return this.$store.state.inview;
    }
  },
  methods: {
    turnOff() {
      this.$store.state.inview = false;
    },
    turnOn() {
      this.$store.state.inview = true;
    },
    changeQuestion() {
      let scrollPos = window.pageYOffset;
      let scrollLength = this.increment * this.site.logos.length;
      let scrollCycles = 0;
      if (window.pageYOffset > scrollLength) {
        scrollCycles = Math.floor(window.pageYOffset / scrollLength);
        scrollPos = scrollPos - scrollCycles * scrollLength;
      }
      this.scrollIndex = Math.floor(scrollPos / this.increment);
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  position: fixed;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  @media only screen and (max-width:768px) {
    position: relative;
    width:100%;
    height:60vh;
  }
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    padding: calc(3 * var(--lh));
    object-fit: contain;
    display: none;
    &.active,
    &.defaultImg {
      display: block;
    }
  }
}
</style>